import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FACTORY_MENU } from '../constant/Factory_main';

@Component({
  selector: 'app-factory-menu',
  templateUrl: './factory-menu.component.html',
  styleUrls: ['./factory-menu.component.css']
})
export class FactoryMenuComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router) { }
  
  CRM = FACTORY_MENU
  userType: string = localStorage.getItem('userTypecon') || '';
  isQcChemist: boolean = false;
   
  ngOnInit(): void {
    this.isQcChemist = this.userType.toUpperCase() === 'QC_CHEMIST';
    this.CRM = this.getFilteredFactoryMenu(this.userType);
  }

  getFilteredFactoryMenu(userType: string) {
    const userTypeUpper = userType.toUpperCase();
    
    // ✅ For QC Chemist - Show only Reports section with 4 specific options
    if (userTypeUpper === 'QC_CHEMIST') {
      return FACTORY_MENU.map(menu => {
        if (menu.heading === 'Reports') {
          return {
            ...menu,
            sub_heading: menu.sub_heading.filter(sub => 
              ['RM QC Dashboard', 'Process QC Dashboard', 'RM QC Process Summary Report', 'QC Process Summary Report'].includes(sub.label)
            )
          };
        }
        // Hide all other sections for QC Chemist
        return {
          ...menu,
          sub_heading: []
        };
      }).filter(menu => menu.heading === 'Reports'); // Show only Reports section
    }

    // For Production Supervisor - filter specific items
    if (userTypeUpper === 'PRODUCTION_SUPERVISOR') {
      return FACTORY_MENU.map(menu => {
        if (menu.heading === 'Factory') {
          return {
            ...menu,
            sub_heading: menu.sub_heading.filter(sub =>
              !['Factory Punching', 'Factory Devices', 'Mobile Punching'].includes(sub.label)
            )
          };
        }
        return menu;
      });
    }

    // For Factory Manager - hide specific sections and sub-items
    if (userTypeUpper === 'FACTORY_MANAGER') {
      return FACTORY_MENU
        .filter(menu => !menu.hideFor?.includes('FACTORY_MANAGER'))
        .map(menu => ({
          ...menu,
          sub_heading: menu.sub_heading.filter(
            (sub: any) => !sub.hideFor?.includes('FACTORY_MANAGER')
          )
        }));
    }

    // Default: return full menu for other Factory roles
    return FACTORY_MENU;
  }

  //--------- Page Routings -----//
  rfr(){
    this.router.navigateByUrl(('admin/RFR')); 
  }

  // Navigation method for factory items
  navigateTo(route: string) {
    if (route) {
      this.router.navigate([route], { relativeTo: this.route });
    }
  }
}